import React, { useEffect } from 'react';
import cn from 'classnames';

// REDUX
import { useAppDispatch, useAppSelector } from '@Managers/Redux/Hooks';
import { getFixesState, setFixesState } from '@Managers/Redux/AppState/AppState';
import arrayCopy from '@Tools/ArrayCopy';

// STYLES
import styles from '../Fixes.scss';

const FixesListButton: React.FC<{ index: number; option: string; predefined?: boolean }> = ({ index, option, predefined = false }) => {
    const dispatch = useAppDispatch();
    const fixesState = useAppSelector(getFixesState);

    function activeFix(index: number, element: string) {
        const _array = arrayCopy(fixesState.fixCombinations);
        _array.push(element);
        dispatch(setFixesState({ fixCombinations: _array }));
    }

    function deleteFix(index: number, fix: string) {
        const _arrayFix = arrayCopy(fixesState.fixArray);
        _arrayFix.splice(index, 1);
        const fixCombination = fixesState.fixCombinations.filter((item) => item !== fix);
        dispatch(setFixesState({ fixArray: _arrayFix, fixCombinations: fixCombination }));
    }

    function previewFix(index: number, fix: string) {
        const values = fix.split(',');
        const obj: { [key: number]: number } = {};

        values.forEach((v, i) => {
            obj[i] = Number(v);
        });
        dispatch(setFixesState({ fixReelPosition: obj }));
        console.log('PREVIEW FX', fix, obj);
    }

    useEffect(() => {}, [fixesState]);

    return (
        <div className={styles.fix_list_item} key={index}>
            <button className={cn(styles.fix_list_option, predefined ? styles.predefined : false)} onClick={() => activeFix(index, option)}>
                {option}
            </button>

            {fixesState.extendedSelector && !predefined && (
                <button className={styles.fix_list_preview} onClick={() => previewFix(index, option)}>
                    P
                </button>
            )}
            {!predefined && (
                <button className={styles.fix_list_delete} onClick={() => deleteFix(index, option)}>
                    X
                </button>
            )}
        </div>
    );
};

export default FixesListButton;
